import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FondoOnere } from '../../../models/fondo-onere';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaFondoOneriAddComponent } from './sezione-economica-fondo-oneri-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-fondo-oneri-add]',
  templateUrl: 'sezione-economica-mod-fondo-oneri-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaFondoOneriModAddComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formFondoOneriAdd') formFondoOneri: SezioneEconomicaFondoOneriAddComponent;

  inizializza(sezione: SezioneEconomica, fondoOnere: FondoOnere, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneEconomica: string, urlReadSezioneLegali: string) {
    this.formFondoOneri.inizializza(sezione, fondoOnere, fascicolo, urlUpdate, urlReadSezioneEconomica, urlReadSezioneLegali);
    openModal('modaleFondoOneriAdd');
  }

  createForm() {
    this.formFondoOneri.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleFondoOneriAdd');
      this.onReturn.emit(sezioneEconomica);
  }
}
